import { Group, GroupProps, type MantineNumberSize, Stack, Text } from '@mantine/core'
import { type CSSProperties, type FC, isValidElement, ReactNode } from 'react'

export interface PropertyListItemProps extends Omit<GroupProps, 'children'> {
  label: string
  labelWidth?: CSSProperties['width']
  size?: MantineNumberSize
  value: ReactNode
}

export const PropertyListItem: FC<PropertyListItemProps> = ({
  label,
  labelWidth = '30%',
  value,
  size = 'sm',
  ...props
}) => (
  <Group
    align='start'
    spacing='xs'
    {...props}
  >
    <Stack
      align='end'
      justify='start'
      w={labelWidth}
    >
      <Text
        align='right'
        size={size}
        weight='bold'
      >
        {label}:
      </Text>
    </Stack>

    <Stack
      align='start'
      justify='start'
      style={{ flex: 1 }}
    >
      {isValidElement(value) ? (
        value
      ) : (
        <Text
          align='start'
          size={size}
        >
          {value || '-'}
        </Text>
      )}
    </Stack>
  </Group>
)
